import { Locale } from '@finxone-platform/shared/enums';
import { AlertTypes } from '@finxone-platform/shared/sys-config-types';
import { FeeManagementErrorCodes } from '../error-codes/fee-management.type';
import { FeeManagementSuccessCodes } from '../success-codes/fee-mangement.type';
import { SupportedToasterLocales } from './general.utils';

export const defaultEnGBFeeManagementTranslations = {
  FEE_CHARGE_ALREADY_APPLIED_TITLE: 'Fee Already Applied',
  FEE_CHARGE_ALREADY_APPLIED_DESCRIPTION:
    'This fee has already been applied or reversed. No further action is needed.',
  FEE_CHARGE_ITEM_NOT_FOUND_TITLE: 'Fee Not Found',
  FEE_CHARGE_ITEM_NOT_FOUND_DESCRIPTION:
    'The requested fee information could not be located. Please verify the details and try again.',
  RETRY_SUCCESSFUL_TITLE: 'Fee Charged Successfully.',
  RETRY_SUCCESSFUL_DESCRIPTION:
    'The fee has been successfully charged to the relevant accounts, and the status updated to "Charged."',
  REVERT_SUCCESSFUL_TITLE: 'Fee Reversal Successful',
  REVERT_SUCCESSFUL_DESCRIPTION:
    'The fee was successfully reversed, and a credit has been applied to applicable accounts.',
  FEE_CHARGE_APPLY_PROCESS_TITLE: 'Fee Charged Failed.',
  FEE_CHARGE_APPLY_PROCESS_DESCRIPTION:
    'Unable to process the fee charge. Please review the set up carefully and try again.',
  FEE_CHARGE_REVERT_PROCESS_TITLE: 'Fee Reversal Failed',
  FEE_CHARGE_REVERT_PROCESS_DESCRIPTION:
    'The fee reversal has failed. Please check the details carefully and try again.',
  FEE_CHARGE_APPLY_PROCESS_CONFIG_TITLE: 'Fee Charge Configuration Error',
  FEE_CHARGE_APPLY_PROCESS_CONFIG_DESCRIPTION:
    'There is a problem with the fee charge configuration.  Please check the set up carefully and try again.',
};

export const feeManagementTranslations: {
  // For new locales just add them here to the extract
  [key in SupportedToasterLocales]: typeof defaultEnGBFeeManagementTranslations;
} = {
  [Locale.en_GB]: defaultEnGBFeeManagementTranslations,
  // Add more locales as needed
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateFeeManagementAlerts = (translations: typeof defaultEnGBFeeManagementTranslations) => ({
  [FeeManagementErrorCodes.FEE_CHARGE_ALREADY_APPLIED]: {
    name: 'Fee charge already applied',
    type: AlertTypes.ERROR,
    title: translations.FEE_CHARGE_ALREADY_APPLIED_TITLE,
    description: translations.FEE_CHARGE_ALREADY_APPLIED_DESCRIPTION,
  },
  [FeeManagementSuccessCodes.FEE_RETRY_SUCCESSFUL]: {
    name: 'Fee charge retry success',
    type: AlertTypes.SUCCESS,
    title: translations.RETRY_SUCCESSFUL_TITLE,
    description: translations.RETRY_SUCCESSFUL_DESCRIPTION,
  },
  [FeeManagementErrorCodes.FEE_CHARGE_ITEM_NOT_FOUND]: {
    name: 'Fee charge item not found',
    type: AlertTypes.ERROR,
    title: translations.FEE_CHARGE_ITEM_NOT_FOUND_TITLE,
    description: translations.FEE_CHARGE_ITEM_NOT_FOUND_DESCRIPTION,
  },
  [FeeManagementErrorCodes.FEE_CHARGE_APPLY_PROCESS]: {
    name: 'Fee charge apply processing error',
    type: AlertTypes.ERROR,
    title: translations.FEE_CHARGE_APPLY_PROCESS_TITLE,
    description: translations.FEE_CHARGE_APPLY_PROCESS_DESCRIPTION,
  },
  [FeeManagementErrorCodes.FEE_CHARGE_APPLY_PROCESS_CONFIG]: {
    name: 'Fee charge config issue',
    type: AlertTypes.ERROR,
    title: translations.FEE_CHARGE_APPLY_PROCESS_CONFIG_TITLE,
    description: translations.FEE_CHARGE_APPLY_PROCESS_CONFIG_DESCRIPTION,
  },
  [FeeManagementSuccessCodes.FEE_REVERT_SUCCESSFUL]: {
    name: 'Fee charge reverted',
    type: AlertTypes.SUCCESS,
    title: translations.REVERT_SUCCESSFUL_TITLE,
    description: translations.REVERT_SUCCESSFUL_DESCRIPTION,
  },
  [FeeManagementErrorCodes.FEE_CHARGE_REVERT_PROCESS]: {
    name: 'Fee charge revert processing error',
    type: AlertTypes.ERROR,
    title: translations.FEE_CHARGE_REVERT_PROCESS_TITLE,
    description: translations.FEE_CHARGE_REVERT_PROCESS_DESCRIPTION,
  },
});
